module.exports = __webpack_public_path__ + "img/img-2.cc0e94b5.webp";